import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import UploadXML from "../../components/UI/UploadXML";

const IntroForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="form-light form-front mt-4">
      <div className="mb-3 py-5 alt text-center">
        <Link to="/editor" className="btn btn-primary btn-lg">
          {t("home.createNewButton")}
        </Link>
      </div>
      <h3 className="text-center mb-0 pt-3">{t("home.uploadHeading")}</h3>
      <div className="dialog-drop">
        <UploadXML
          onAction={() => {
            navigate("/editor");
          }}
        />
      </div>
    </div>
  );
};

export default IntroForm;
